export const urlParams = {
  search: 'search',
};
